import { StyleSheet } from "react-native";

import { makeStyles } from "@/theme/makeStyles";

/** Shared layout for the shell's full-screen states (loading, errors, not-found, placeholders). */
export const useScreenStyles = makeStyles((t) =>
  StyleSheet.create({
    screen: { flex: 1, backgroundColor: t.color.background },
    body: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      padding: t.space.x2l,
      gap: t.space.md,
    },
    message: { textAlign: "center", maxWidth: 480 },
  }),
);
